import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

import { initSentry } from '@pv/common/sentry';
import './components/MuiXLicense';

const dsn = process.env.REACT_APP_SENTRY_DSN as string;
initSentry({ dsn });

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
